import { CommerceFilesService } from './../../_services/commerce-files.service';
import { CommerceFilesChangeFileRequest } from '../../_models/commerce-files-change-file-request.model';
import { CommerceFiles } from '../../_models/commerce-files.model'
import { Component, ElementRef, OnInit, QueryList, signal, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Contact } from 'src/app/_models/contact.model';
import { AuthService } from 'src/app/_services/auth.service';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { CommerceFilesCreate } from 'src/app/_models/commerce-files-create.model';
import { DocumentType } from 'src/app/_enums/documentType';
import { FileUploadComponent } from 'src/app/components/file-upload/file-upload.component';
import { ContactListComponent } from 'src/app/components/contact-list/contacts-list.component';
import { CommerceFilesUpdate } from 'src/app/_models/commerce-files-update.model';
import { DownloadFileComponent } from 'src/app/components/download-file/download-file.component';
import { BehaviorSubject } from 'rxjs';
import { ContactGroupService } from 'src/app/_services/contact-group.service';
declare var jQuery: any; // fix para que jquery para modal funcione

@Component({
  selector: 'DMF-client-file-configuration',
  templateUrl: './client-file-configuration.component.html',
  standalone: false,
})
export class ClientFileConfigurationComponent extends BaseComponent implements OnInit {

  @ViewChildren(FileUploadComponent) fileUploadComponents: QueryList<FileUploadComponent>;
  @ViewChild(DownloadFileComponent) downloadFileComponent: DownloadFileComponent;
  @ViewChildren(ContactListComponent) contactListComponents: QueryList<ContactListComponent>;
  @ViewChild('addFileModal') addFileModal: ElementRef;
  @ViewChild('changeFileModal') changeFileModal: ElementRef;
  @ViewChild('editModal') editModal: ElementRef;
  @ViewChild('successModal') successModal: ElementRef;

  readonly panelOpenState = signal(false);

  private taskCompletedSubject = new BehaviorSubject<boolean>(false);
  taskCompleted$ = this.taskCompletedSubject.asObservable();

  contacts: Contact[] = [];
  tokenData: any;
  commerceFile: CommerceFiles;
  commerceFileList: CommerceFiles[] = [];
  commerceFileVersions: CommerceFiles[] = [];
  commerceFileDownloads: CommerceFiles[] = [];
  commerceFilesChangeFileRequest: CommerceFilesChangeFileRequest = {
    fileName: '',
    extension: '',
    file: '',
  };
  commerceFileCreate: CommerceFilesCreate = {
    fileName: "",
    extension: "",
    description: "",
    documentType: null,
    created: new Date(),
    createdBy: '',
    file: "",
    contacts: []
  };
  selectedCommerceFileId: number | null = null;
  base64File: string | null = null;
  selectedFileName: string;
  successMessage: string = '';
  documentTypeList: string[] = [];
  documentType = DocumentType;
  descriptionVersion: string;
  documentTypeVersion: string;
  editFile: CommerceFiles;
  editLstContacts: Contact[] = [];
  commerceFileUpdate: CommerceFilesUpdate;
  loadCompleted: boolean = false;
  documentAssignments: Record<string, CommerceFiles[]> = {};
  selectedDocumentType: string;
  selectedContactGuid: string;

  expandedItemIndex: number | null = null;
  expanded: boolean = false;
  showDownloadFile: boolean = true;

  clientFileErrorMessage: boolean = false;

  isAllSelected: boolean = false;
  selectedContacts: any[] = [];

  constructor(
    public override router: Router,
    public override langService: LanguageManagerService,
    private contactGroupService: ContactGroupService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private commerceFilesService: CommerceFilesService,
    private elementRef: ElementRef
  ) {
    super(router, langService, route)
  }

  override ngOnInit(): void {
    this.getDocumentType();
    super.ngOnInit();
    this.tokenData = this.authService.getTokenData();
    this.getContactList(this.tokenData.contactGroupId);
    this.getAll("");


    this.documentAssignments[this.documentType.CANCELLATION_POLICY] = [];
    this.documentAssignments[this.documentType.DENIAL_POLICY] = [];
    this.documentAssignments[this.documentType.GENERAL_CONDITIONS] = [];
    this.documentAssignments[this.documentType.OTHER_DOCUMENTS] = [];

    this.loadCompleted = true
  }

  getAll(documentType?: string, contactIdGuid?: string) {
    this.selectedContactGuid = null;
    this.selectedDocumentType = null;
    this.commerceFilesService.getAll(documentType, contactIdGuid).subscribe(
      (res) => {
        this.documentAssignments[documentType] = res;
        this.clearFormModal();
        this.commerceFileList = res;
      }, (error) => {
        this.clearFormModal();
        if (error.status == 404) {
          this.showModalMessage('Error al encontrar los documentos.');
        };
      }
    );
  }

  getDocumentType() {
    this.commerceFilesService.GetDocumentType().subscribe({
      next: (res) => {
        this.documentTypeList = res;
      },
      error: (err) => {
        this.clearFormModal();
        if (err.status == 404) {
          this.showModalMessage('Error al encontrar los tipos de documentos.');
        };
      }
    });
  }

  getContactList(contactGroupId: string) {
    this.contactGroupService.getContactsByContactGroupId(contactGroupId).subscribe({
      next: (response) => {
        this.contacts = response;
      },
      error: (error) => {
        this.clearFormModal();
        if (error.status == 404) {
          this.showModalMessage('Error al encontrar los contactos.');
        };
      }
    });
  }

  openAddModal() {
    jQuery(this.addFileModal.nativeElement).modal('show');
  }

  onFileSelected(file: File | null): void {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Lee el archivo y lo codifica en Base64
      reader.onload = () => {
        this.base64File = (reader.result as string).split(',')[1];
        this.selectedFileName = file.name;
      };
      reader.onerror = (error) => {
        console.error('Error al leer el archivo:', error);
      };
    } else {
      this.base64File = null;
      this.selectedFileName = '';
    }
  }

  // Aceptar fichero añadido
  addFile(): void {
    if (this.commerceFileCreate.description && this.commerceFileCreate.documentType && this.commerceFileCreate.contacts && this.selectedFileName && this.base64File) {
      this.commerceFileCreate.fileName = this.selectedFileName.split('.').slice(0, -1).join('.'); // Dejo solo el nombre del archivo sin extension.
      this.commerceFileCreate.extension = this.selectedFileName.split('.').pop() || '';
      this.commerceFileCreate.createdBy = this.tokenData.name;
      this.commerceFileCreate.file = this.base64File;
    } else {
      return; // Salir si no se ha seleccionado un archivo
    }
    this.createCommerceFile(this.commerceFileCreate);
    jQuery(this.addFileModal.nativeElement).modal('hide');
  }

  // Llamada para crear el nuevo archivo
  createCommerceFile(data: CommerceFilesCreate): void {
    this.commerceFilesService.createFile(data).subscribe({
      next: (response) => {
        this.closeModal();
        this.showModalMessage('Archivo creado con éxito.');
      },
      error: (error) => {
        this.closeModal();
        this.showModalMessage('Error al crear archivo.');
      }
    });
  }

  // Contacts seleccionados en el modal al añadir
  onContactsSelected(selectedContacts: Contact[]): void {
    this.commerceFileCreate.contacts = selectedContacts;

    this.isAllSelected = selectedContacts.length === this.contacts.length;
  }

  toggleSelectAll(): void {
    if (this.contactListComponents) {
      this.contactListComponents.forEach((contactListComponent) => {
        contactListComponent.setAllCheckboxes(this.isAllSelected);
      });
    }
  }

  // Contacts seleccionados en el modal al editar
  onEditContactsSelected(selectedContacts: Contact[]): void {
    this.editFile.contacts = selectedContacts;
  }

  openChangeModal(commerceFileId: number) {
    this.selectedCommerceFileId = commerceFileId;
    jQuery(this.changeFileModal.nativeElement).modal('show');
  }

  commerceFileRequest(commerceFilesId: number) {
    if (this.selectedFileName && this.base64File) {
      this.commerceFilesChangeFileRequest.fileName = this.selectedFileName.split('.').slice(0, -1).join('.'); // Dejo solo el nombre del archivo sin extension.
      this.commerceFilesChangeFileRequest.extension = this.selectedFileName.split('.').pop() || '';
      this.commerceFilesChangeFileRequest.file = this.base64File;
    } else {
      return; // Salir si no se ha seleccionado un archivo
    }
    // Cambiamos archivo
    this.changeFile(commerceFilesId, this.commerceFilesChangeFileRequest);
    jQuery(this.changeFileModal.nativeElement).modal('hide');
  }

  // Llamada para cambiar archivo
  changeFile(commerceFilesId: number, commerceFilesChangeFileRequest: CommerceFilesChangeFileRequest) {
    this.commerceFilesService.changeFile(commerceFilesId, commerceFilesChangeFileRequest).subscribe({
      next: (response) => {
        this.closeModal();
        this.showModalMessage('El archivo se ha cambiado correctamente.');
      },
      error: (error) => {
        this.closeModal();
        if (error.status === 409) {
          this.showModalMessage('El archivo ya existe. Por favor, elije un archivo diferente.');
          this.closeModal();
        } else {
          this.showModalMessage('Hubo un error al intentar cambiar el archivo. Por favor, inténtelo de nuevo.');
          this.closeModal();
        }
      }
    });
  }

  // Mostrar modal con la respuesta despues de añadir o cambiar archivo
  showModalMessage(message: string) {
    this.successMessage = message;
    jQuery(this.successModal.nativeElement).modal('show');
  }

  // Limpia campos de formulario del modal
  clearFormModal(): void {
    this.commerceFileCreate = {
      fileName: "",
      extension: "",
      description: "",
      documentType: null,
      created: new Date(),
      createdBy: '',
      file: "",
      contacts: []
    };
    this.commerceFilesChangeFileRequest = {
      fileName: '',
      extension: '',
      file: ''
    };
    this.selectedFileName = "";
    this.base64File = "";
  }

  versiones(commerceFileId: number, description: string, documentType: string) {
    this.commerceFilesService.getVersions(commerceFileId).subscribe({
      next: (res) => {
        this.clearFormModal();
        this.commerceFileVersions = res.data;
        this.descriptionVersion = description;
        switch (documentType) {
          case 'GENERAL_CONDITIONS':
            this.documentTypeVersion = "DCO.ClientFileConfiguration_GeneralConditions";
            break;
          case 'CANCELLATION_POLICY':
            this.documentTypeVersion = "DCO.ClientFileConfiguration_CancellationPolicy";
            break;
          case 'DENIAL_POLICY':
            this.documentTypeVersion = "DCO.ClientFileConfiguration_DenialPolicy";
            break;
          case 'OTHER_DOCUMENTS':
            this.documentTypeVersion = "DCO.ClientFileConfiguration_OtherDocuments";
            break;
          default:
            break;
        }
      }, error: (error) => {
        this.clearFormModal();
        if (error.status == 404) {
          this.showModalMessage('Error al encontrar las versiones.');
        };
      },
      complete: () => {
        this.taskCompletedSubject.next(true);
      }
    });
  }

  downloadFile(commerceFileId: number) {
    this.commerceFilesService.getVersions(commerceFileId).subscribe({
      next: (res) => {
        this.commerceFileDownloads = res.data;
      }, error: (error) => {
        this.clearFormModal();
        if (error.status == 404) {
          this.showModalMessage('Error al encontrar las versiones.');
        };
      },
      complete: () => {
        if (this.commerceFileDownloads && this.commerceFileDownloads.length > 0) {
          const latestFile = this.commerceFileDownloads[0];
          if (this.downloadFileComponent) {
            this.downloadFileComponent.fileId = latestFile.commerceFileHistoricID;
            this.downloadFileComponent.downloadFile();
          }
        }
        this.taskCompletedSubject.next(true);
      }
    });
  }

  delete(commerceFileId: number) {
    const confirmation = confirm("¿Estás seguro de que deseas eliminar este elemento?");
    if (confirmation) {
      this.commerceFilesService.delete(commerceFileId).subscribe(
        (res) => {
          this.clearFormModal();
          this.showModalMessage('Archivo eliminado correctamente.');
        }, (error) => {
          this.clearFormModal();
          if (error.status == 400) {
            this.showModalMessage('Error al eliminar el archivo.');
          };
        }
      );
    } else {
    }
  }

  onClientFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files?.length) {
      this.clientFileErrorMessage = false;
      return;
    }

    const file = input.files[0];
    this.clientFileErrorMessage = false; // Reiniciar error en cada intento

    // Validación de Tamaño (Máximo 10MB)
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      this.clientFileErrorMessage = true;
      input.value = ''; // Limpia el input HTML
      return;
    }

    // Validación de Formato
    const allowedExtensions = ['pdf', 'docx', 'doc', 'jpg', 'jpeg', 'png'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      this.clientFileErrorMessage = true;
      input.value = '';
      return;
    }
    this.openAddModal();
  }

  // Cerrar y limpiar modal
  closeModal(): void {
    if (this.fileUploadComponents) {
      // Limpiar todas las instancias del componente FileUploadComponent
      this.fileUploadComponents.forEach((fileUploadComponent) => {
        fileUploadComponent.clearFileSelection();
      });
    }
    // Limpiar los checkboxes de todas las instancias de ContactListComponent
    if (this.contactListComponents) {
      this.contactListComponents.forEach((contactListComponent) => {
        contactListComponent.clearCheckboxes();
      });
    }
    // Limpiar restos de campos del modal
    this.isAllSelected = false;
    this.clearFormModal();
    jQuery(this.addFileModal.nativeElement).modal('hide');
    jQuery(this.changeFileModal.nativeElement).modal('hide');
    jQuery(this.successModal.nativeElement).modal('hide');
    this.getAll("");
  }

  openEditModal(commerceFile: CommerceFiles) {
    this.editFile = commerceFile;
    // Mostramos listado completo de contacts recuperando los que ya tenia seleccionados.
    this.contacts.forEach(contact => {
      contact.selected = !!this.editFile.contacts.find(c => c.contactId === contact.contactId);
    });
    jQuery(this.editModal.nativeElement).modal('show');
  }

  update() {
    if (this.editFile) {
      this.commerceFileUpdate = {
        description: this.editFile.description,
        contacts: this.editFile.contacts
      };

      this.commerceFilesService.update(this.editFile.commerceFileId, this.commerceFileUpdate).subscribe({
        next: (response) => {
          // this.getAll("");
          this.closeModal();
          this.showModalMessage('Actualizado con éxito.');
        },
        error: (error) => {
          this.showModalMessage('Error al actualizar.');
        }
      });
      jQuery(this.editModal.nativeElement).modal('hide');
    }
  }

  toggleCollapse(index: number) {
    this.expandedItemIndex = this.expandedItemIndex === index ? null : index;
    this.expanded = !this.expanded;
  }

  Search() {
    this.commerceFileList = new Array;
    if ((<
      HTMLInputElement
      >document.getElementById('documentType')).value != "null") {
      this.selectedDocumentType = (<
        HTMLInputElement
        >document.getElementById('documentType')).value;
    }

    if ((<
      HTMLInputElement
      >document.getElementById('comerceType')).value != "null") {
      this.selectedContactGuid = (<
        HTMLInputElement
        >document.getElementById('comerceType')).value;
    }
    if (this.selectedContactGuid == "All") {
      this.selectedContactGuid = ""
    }

    if (this.selectedDocumentType == "All") {
      this.selectedDocumentType = ""
    }
    this.getAll(this.selectedDocumentType, this.selectedContactGuid)
  }
}
